import { ChangeDetectorRef, Component, EventEmitter, inject, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-base-list',
    template: '',
    styles: [],
    standalone: false
})
export class BaseViewComponent {

  privateRouter = inject(Router);
  cdr = inject(ChangeDetectorRef);
  location = inject(Location);

  @Output()
  closeEvent = new EventEmitter<any>();

  history: any = [];
  currentChild = 0;
  showChild = false;
  loadRoute = false;
  reload = false;

  setData(data: any) : any { }

  getChild(id: any){ }

  get() { }

  close(reload = true) {
    if (!this.loadRoute) {
      this.closeEvent.emit(reload);
      this.reload = false;
    } else {
      this.location.back();
    }
  }
}
